// Lookup map: template_name -> ECharts option builder.
//
// `table` is intentionally NOT in this map — it isn't an ECharts option
// at all; ChartCard branches on template_name === "table" and renders
// the ag-grid component instead. Adding new ECharts templates: drop a
// new file in this folder and register it here.

import type { ChartRow } from "../types";
import { buildBarGrouped } from "./bar_grouped";
import { buildLineTimeseries } from "./line_timeseries";
import { buildDonut } from "./donut";
import { buildHorizontalBar } from "./horizontal_bar";
import { buildAreaStacked } from "./area_stacked";
import { buildHeatmap } from "./heatmap";
import { buildGeoScatter } from "./geo_scatter";

export type EChartsBuilder = (
  input: Record<string, unknown>,
  rows: ChartRow[],
  columns: string[],
  title: string,
  palette: ReadonlyArray<string>,
) => Record<string, unknown>;

export const ECHARTS_TEMPLATES: Record<string, EChartsBuilder> = {
  bar_grouped: buildBarGrouped as unknown as EChartsBuilder,
  line_timeseries: buildLineTimeseries as unknown as EChartsBuilder,
  donut: buildDonut as unknown as EChartsBuilder,
  horizontal_bar: buildHorizontalBar as unknown as EChartsBuilder,
  area_stacked: buildAreaStacked as unknown as EChartsBuilder,
  heatmap: buildHeatmap as unknown as EChartsBuilder,
  geo_scatter: buildGeoScatter as unknown as EChartsBuilder,
};

export const TABLE_TEMPLATE_NAME = "table";
